export class SprayRecord {

  id: string;
  date: string;
  stage: string; // bloom, petal fall, 8-10mm, 10-12mm, 12-14mm, 14-16mm, 16-18mm, 18-20mm, 20-22mm)
  chemical: string;

  static stageLabels = {
    'bloom': 'Bloom',
    'petal_fall': 'Petal Fall',
    '8_10': '8-10mm',
    '10_12': '10-12mm',
    '12_14': '12-14mm',
    '14_16': '14-16mm',
    '16_18': '16-18mm',
    '18_20': '18-20mm',
    '20_22': '20-22mm'
  };

  constructor(private fields: any) {
    this.fields = fields;

    // Quick and dirty extend/assign fields to this model
    for (let f in fields) {
      this[f] = fields[f];
    }
  }

  getStageLabel() {
    return SprayRecord.stageLabels[this.stage];
  }

}



// WEBPACK FOOTER //
// ./src/models/spray-record.ts